import React from "react";
import SearchField from "./SearchField";
import {Col, Row} from "antd";
import NavMenu from "./NavMenu";
import Action from "./Action";
import './filter.css';

const FilterContainer = ({onSearchChange}) => {

    return (
        <Row gutter={{xs: 86, sm: 86, md: 46, lg: 36}} className="mb-20 sm-mt-0 mt-20 w-full">
            {/*<Col md={8} lg={8} className="gutter-row">*/}
            {/*    <SearchField onChangeHandler={onSearchChange} />*/}
            {/*</Col>*/}
            {/*<Col md={18} lg={18} className="gutter-row">*/}
            {/*    <NavMenu />*/}
            {/*</Col>*/}
            <Col md={24} lg={24} className="gutter-row justify-end sm-justify-center flex flex-wrap gap-x-2 gap-y-4">
                <NavMenu />
                <Action />
            </Col>
        </Row>
    )
}

export default FilterContainer;